import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';

/**
 * Thin wrapper around Framer Motion that fades and slides content into view
 * when it enters the viewport (once only).
 */
function RevealOnScroll({ delay, y, children }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.5, delay, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  );
}

RevealOnScroll.propTypes = {
  delay: PropTypes.number,
  y: PropTypes.number,
  children: PropTypes.node.isRequired,
};

RevealOnScroll.defaultProps = {
  delay: 0,
  y: 24,
};

export default RevealOnScroll;
